export const Roles  = [
    'Villageois',
    'Loup garou',
    'Voyante',
    'Sorcière',
    'Chasseur',
    'Cupidon',
    'Petite Fille',
    'Gardien',
    'Dictateur'
]

export const DefaultRoles = [
    'Villageois',
    'Loup garou',
    'Voyante', 
    'Sorcière',
    'Chasseur',
    'Cupidon',
    'Gardien'
]